<style scoped>
.contet_title {
  font-size: 22px;
  padding-top: 25px;
  padding-bottom: 20px;
  text-align: center;
  font-weight: bold;
}
.content--box {
  padding: 15px;
  box-sizing: border-box;
}
</style>

<template>
  <div>
    <div class="contet_title">
      {{ title }}
    </div>
    <div class="content--box">
      <p class="MsoNormal">
        <span
          >为规范食物安全事故应急处置工作，及时高效、合理有序地处理食品安全事故，把损失减少到最小，根据《食品安全法》、《食品经营许可管理办法
          》、《餐饮服务食品安全操作规范》、《新疆维吾尔自治区食品经营许可管理实施办法》（试行）、《新疆维吾尔自治区食品经营许可审查细则》（试行）等法律法规和规章要求，结合本单位的实际情况，制定本方案。</span
        ><span><o:p></o:p></span>
      </p>
      <p class="MsoNormal">
        <b><span>一、应急处置程序</span></b
        ><b
          ><span><o:p></o:p></span
        ></b>
      </p>
      <p class="MsoNormal">
        <span>(一)及时报告</span><span><o:p></o:p></span>
      </p>
      <p class="MsoNormal">
        <span
          >发生食品安全事故后，有关人员应立即停止生产经营活动，封存导致或者可能导致食品安全事故的食品及其原料、工具及用具、设备设施和现场。</span
        ><span><o:p></o:p></span>
      </p>
      <p class="MsoNormal">
        <span
          ><font>自事故发生之时起</font
          ><font
            >2小时内向所在地县级人民政府卫生部门和市场监督管理部门报告，报告内容有：发生食品安全事故的单位、地址、时间、中毒人数及死亡人数，主要临床表现，可能引起中毒的食物等，并按照相关监管部门的要求采取控制措施。</font
          ></span
        ><span><o:p></o:p></span>
      </p>
      <p class="MsoNormal">
        <span>(二)立即抢救</span><span><o:p></o:p></span>
      </p>
      <p class="MsoNormal">
        <span>在第一时间组织人员，立即将中毒者送医院抢救。</span
        ><span><o:p></o:p></span>
      </p>
      <p class="MsoNormal">
        <span>(三)保护现场</span><span><o:p></o:p></span>
      </p>
      <p class="MsoNormal">
        <span
          ><font
            >发生食物中毒后，在向有关部门报告的同时要保护好现场和可疑食物，病人吃剩的食物不要急于倒掉，食品用工具容器、餐具等不要急于冲洗，病人的排泄物</font
          ><font>(呕吐物、大便)要保留，提供留样食物。</font></span
        ><span><o:p></o:p></span>
      </p>
      <p class="MsoNormal">
        <span>(四)配合调查</span><span><o:p></o:p></span>
      </p>
      <p class="MsoNormal">
        <span
          >负责人及有关工作人员，要配合市场监督管理部门进行食品安全事故调查处理如实反映食品安全事故情况。将病人所吃的食物，病人中毒的主要特点，可疑食物的来源、质量、存放条件、加工烹调的方法和加热的温度、时间等情况如实向调查部门反映。</span
        ><span><o:p></o:p></span>
      </p>
      <p class="MsoNormal">
        <b><span>二、事故责任追究</span></b
        ><b
          ><span><o:p></o:p></span
        ></b>
      </p>
      <p class="MsoNormal">
        <span
          ><font
            >对事故延报、谎报、瞒报、漏报或处置不当的，要追究当事人责任</font
          ><font
            >;负责人做好中毒人员的安抚工作，确保不让事态扩大，任何个人不得自行散布事故情况信息，造成严重后果的将追究其法律责任。</font
          ></span
        ><span><o:p></o:p></span>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      title: "",
    };
  },
  created() {
    this.title = this.$route.query.data;
  },
  methods: {},
};
</script>
